import { EnvironmentEnum, EnvironmentModel } from '@mlc/types';
import { AppflowEnvEnum } from 'src/app/core/models/enums/appflowEnv.enum';

export const environment: EnvironmentModel = {
  production: true,
  baseUrl: 'https://mlc-strapi-asset-manager-prod-mhtfux2ooa-ew.a.run.app/api',
  ENV: EnvironmentEnum.PRODUCTION,
  APPFLOW_ENV: AppflowEnvEnum.PRODUCTION,
  APPFLOW_ID: '69915caf',
  SENTRY_LINK: 'https://679b7cba5ed0b4cc4ef3cb4077c1d7f8@o4507406465171456.ingest.de.sentry.io/4507406466547792',
  COIN_MARKET_CAP_URL: 'https://coinmarketcap.com/fr/currencies'
};
